import { AxiosResponse } from "axios";
import { ISupplyOrder } from "domain/Inventory/Models/ISupplyOrder";
import { ISupplyOrderSummary } from "domain/Inventory/Models/ISupplyOrderSummary";
import { IComposedFilter } from "domain/Utils";
import { IConfigCSVErrors } from "domain/Config/Models/IConfigCSVErrors";
import { useRequest } from "hooks/useRequest";
import i18n from "i18n";

const buildFilterBody = (filter?: IComposedFilter) => ({
	categories:
		filter?.filter
			?.filter((c) => c.type === "category")
			.map((c) => ({ id: c.id, name: c.name })) ?? [],
	stores:
		filter?.filter
			?.filter((c) => c.type === "store")
			.map((c) => ({ id: c.id, name: c.name })) ?? [],
	products:
		filter?.filter
			?.filter((c) => c.type === "product")
			.map((c) => ({ id: c.id, name: c.name })) ?? [],
	tags:
		filter?.filter?.filter((c) => c.type === "tag").map((c) => c.name) ??
		[],
});

const buildDateRange = (filter?: IComposedFilter) => {
	const start = filter?.picker?.range?.startDate;
	const end = filter?.picker?.range?.endDate;
	return `start=${start?.toFormat("yyyy-MM-dd") ?? ""}&end=${end?.toFormat("yyyy-MM-dd") ?? ""}`;
};

export const useSupplyOrderRequester = () => {
	const request = useRequest("SupplyOrders");

	return {
		getAll: (
			skip = 0,
			take = 100,
			filter?: IComposedFilter,
			receiveds = false,
		) => {
			return request
				.POST(
					`?${buildDateRange(filter)}&skip=${skip}&take=${take}&receiveds=${receiveds}`,
					buildFilterBody(filter),
				)
				.then((res: AxiosResponse<ISupplyOrder[]>) => res.data);
		},
		getCount: (filter?: IComposedFilter, receiveds = false) =>
			request
				.POST(
					`count?${buildDateRange(filter)}&receiveds=${receiveds}`,
					buildFilterBody(filter),
				)
				.then((res: AxiosResponse<ISupplyOrderSummary>) => res.data),
		createOrders: (orders: Partial<ISupplyOrder>[]) =>
			request
				.POST(`upsert`, orders)
				.then((res: AxiosResponse<number>) => res.data),
		importCSV: (file: File) => {
			const formData = new FormData();
			formData.append("file", file);

			return request.POST(`validateCSV/${i18n.language}`, formData).then(
				(
					res: AxiosResponse<{
						item1: string;
						item2: IConfigCSVErrors[];
					}>,
				) => ({
					guid: res.data.item1,
					errors: res.data.item2,
				}),
			);
		},
		saveCSV: (guid: string) => {
			return request
				.POST(`saveCSV/${guid}`, {})
				.then((res: AxiosResponse<IConfigCSVErrors[]>) => res.data);
		},
	};
};
